module.exports = __webpack_public_path__ + "static/img/transcript-logo.a252fc51.svg";